import { defineEndpoint } from '@nzyme/rpc/defineEndpoint.js';
import * as z from 'zod/mini';
import { Id } from '@sigma/common/schema/Id.js';
export const FileGetEndpointParams = z.object({
    /** File IDs to retrieve metadata for */
    fileIds: z.array(Id),
});
/**
 * Endpoint for getting file metadata with signed URLs.
 * Returns metadata only for files the user has access to.
 */
export const FileGetEndpoint = defineEndpoint({
    name: 'FileGet',
    input: FileGetEndpointParams,
    output: defineEndpoint.output(),
});
//# sourceMappingURL=FileGetEndpoint.js.map